import { defineComponent as c, useCssModule as p, computed as t, inject as i, ref as u, openBlock as d, createElementBlock as f, normalizeClass as C, unref as n } from "vue";
import _ from "../../utils/propValidator.mjs";
import v from "../../utils/mapClasses.mjs";
import { motionKey as y } from "../../types/symbols.mjs";
const o = "cdr-skeleton-bone", b = /* @__PURE__ */ c({
  name: "CdrSkeletonBone",
  __name: "CdrSkeletonBone",
  props: {
    /**
     * Sets the type of content placeholder
     * @demoSelectMultiple false
     * @values default, heading, line, rectangle, square
    */
    type: {
      type: String,
      default: "default",
      validator: (e) => _(e, ["default", "heading", "line", "rectangle", "square"])
    }
  },
  setup(e) {
    const s = e, a = p(), l = t(() => `${o}--${s.type}`), r = i(y, u(!0)), m = t(() => r.value ? `${o}__shimmer` : "");
    return (g, k) => (d(), f("div", {
      class: C(n(v)(n(a), o, l.value, m.value))
    }, null, 2));
  }
});
export {
  b as default
};
